import './ccf-accordion-summary.module.scss';
import { AccordionSummary, AccordionSummaryProps } from '@mui/material';


/**
 * CcfAccordionSummary used to display react AccordionSummary details
 * @param param - AccordionSummaryProps
 * @example <CcfAccordionSummary />
 */
export function CcfAccordionSummary({children, ...rest}: AccordionSummaryProps) {
  return <AccordionSummary {...rest}> {children}</AccordionSummary>
}

export default CcfAccordionSummary;